


















import mixin from './cardmixin.vue'
import Vue from 'vue'
import dayjs from 'dayjs'
import { MachineServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
const assp = new MachineServiceProxy()

export default Vue.extend({
  name: 'repeat-custom-device',
  mixins: [mixin],
  data() {
    return {
      data: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_ops_machine_machine_serialNo'),
          dataIndex: 'serialNo',
          width: 100
        },
        {
          title: this.$t('page_ops_machine_search_customer_name'),
          dataIndex: 'customerName',
          ellipsis: true,
          width: 260,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: this.$t('page_plan_create_user'),
          dataIndex: 'createUser',
          width: 100
        },
        {
          title: this.$t('page_ops_work_record_submit_time'),
          dataIndex: 'createTime',
          width: 120,
          ellipsis: true,
          customRender: (t) => {
            return dayjs(t).format('YYYY-MM-DD HH:mm:ss') || ''
          }
        }
      ]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    navTo(keyWord) {
      this.ViewMOre('screening-customers-table', {keyWord});
    },
    getTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    async getList() {
      const data = await assp.getRepeatedSerialNoMachineList()
      this.data = data
      this.checkScrollY('device-alarm', this.data.length)
    }
  }
})
